import { render, staticRenderFns } from "./InspectionCount.vue?vue&type=template&id=4cab983a&"
import script from "./InspectionCount.vue?vue&type=script&lang=js&"
export * from "./InspectionCount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports